
























































import api from '@/common/api';
import dateFormat from 'dateformat';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import { EntityFilterType } from '@/common/components/entities/entities.types';
import EntitiesTable from '@/common/components/entities/EntitiesTable.vue';
import { Processor, ProcessorType } from '@/common/types/processors.types';
import { AchAccountHolderType } from '@/common/types/payments.types';
import { Batch } from '../components/batches/batches.types';

export default Vue.extend({
  data() {
    return {
      openBatchLoaded: false as boolean,
      openBatchObj: {} as object,
      EntityFilterType,
      config: {
        pageTitle: 'Batch Settlements Report',
        apiPath: 'batches',
        header: 'Batch Settlements Report',
        routerBase: 'merchant.batches',
        entityName: 'batch',
        identifierProperty: 'id',
        reportFileName: 'batch_settlements_report',
        filters: [
          {
            name: 'dateStartCreatedAt',
            display: 'Start Date',
            type: EntityFilterType.DATE,
            value: dateFormat(
              new Date(new Date().getFullYear(), new Date().getMonth(), 1),
              'yyyy-mm-dd',
            ),
            open: false,
          },
          {
            name: 'dateEndCreatedAt',
            display: 'End Date',
            type: EntityFilterType.DATE,
            value: dateFormat(new Date(), 'yyyy-mm-dd'),
            open: false,
          },
          {
            name: 'batchNumber',
            display: 'Batch Number',
            value: '',
            type: EntityFilterType.TEXT,
          },
          {
            name: 'processorUuid',
            display: 'Processor Name',
            value: '',
            type: EntityFilterType.SELECT_CHECK,
            items: [] as Processor[],
          },
        ],
        headers: [
          { text: 'ID', value: 'id', align: ' d-none' },
          {
            text: 'Settlement Date',
            value: 'settledAt',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '15rem',
          },
          {
            text: 'Batch Number',
            value: 'batchNumber',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '10rem',
          },
          {
            text: 'Status',
            value: 'status',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '10rem',
          },
          {
            text: 'Transaction Count',
            value: 'transactionCount',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '14rem',
          },
          {
            text: 'Volume',
            value: 'volume',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
          },
          {
            text: 'Refunds',
            value: 'refundAmount',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
          },
          {
            text: 'Net Amount',
            value: 'netAmount',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '10rem',
          },
          {
            text: 'Processor Name',
            value: 'processorName',
            class: 'entity-table-header subtitle-2 font-weight-bold black--text',
            width: '15rem',
          },
        ],
        footer: {
          header: 'Totals',
          displayHeaders: ['transactionCount', 'volume', 'refundAmount', 'netAmount'],
          displayFunction(filters: any, entities: any[], header: string) {
            if (header === 'transactionCount') {
              return entities.reduce((sum: number, item: Batch) => sum + item.transactionCount, 0);
            }
            if (header === 'volume') {
              const formatted = filters.dollarsAndCents(
                entities.reduce((sum: number, item: Batch) => sum + item.volume, 0),
              );
              return `$${formatted}`;
            }
            if (header === 'refundAmount') {
              const formatted = filters.dollarsAndCents(
                entities.reduce((sum: number, item: Batch) => sum + item.refundAmount, 0),
              );
              return `$${formatted}`;
            }
            if (header === 'netAmount') {
              const formatted = filters.dollarsAndCents(
                entities.reduce((sum: number, item: Batch) => sum + item.netAmount, 0),
              );
              return `$${formatted}`;
            }
            return '';
          },
        },
      },
    };
  },
  components: {
    EntitiesTable,
  },
  mounted() {
    this.getOpenBatch();
    this.$store
      .dispatch('loadMerchantProcessors', this.context)
      .then(() => {
        const processorFilter = this.config.filters.find((pf) => pf.name === 'processorUuid');
        if (processorFilter) {
          Object.assign(processorFilter.items, this.processors
            .filter((it: any) => !(
              it.key === ProcessorType.PAYA && it.config?.type === AchAccountHolderType.PERSONAL
            ))
            .map((it: Processor) => ({
              display: it.name,
              value: it.id,
            })));
        }
      })
      .catch(() => {
        this.$toasted.error('Failed to load processors!');
      });
  },
  computed: {
    ...mapGetters(['processors', 'context']),
  },
  methods: {
    reloadOpenBatch(params: any) {
      this.getOpenBatch(params);
    },
    getOpenBatch(params?: any) {
      api
        .get('/batches/open-batch', { params })
        .then(({ data }) => {
          this.openBatchLoaded = true;
          this.openBatchObj = data.data!;
        })
        .catch(() => {
          this.$toasted.error('Failed to load open batch data. Try again later!');
        });
    },
    getAmount(amount: number) {
      if (amount < 0) {
        const absAmount = Math.abs(amount);
        return `($${(this.$options.filters as any).dollarsAndCents(absAmount)})`;
      }

      return `$${(this.$options.filters as any).dollarsAndCents(amount)}`;
    },
    netAmountClass(amount: number) {
      return (amount < 0) ? 'red--text' : '';
    },
  },
});
